// Single source of truth for the ordered project "pages" (sites).
// Used by the Navbar (Projekt-Seiten group) and the ProjectPageNav prev/next
// navigator. Feature/action entries (Neue Maßnahme, Projektkopie senden) and global
// entries (Home, Projekte, Change Password) are intentionally NOT part of this
// page sequence.
export interface ProjectPage {
  route: string;
  label: string;
  icon: string;
}

export const PROJECT_PAGES: ProjectPage[] = [
  { route: "ProjectDetails", label: "Projektdetails", icon: "mdi-rename-box" },
  { route: "ProjectDashboard", label: "Maßnahmen", icon: "mdi-database" },
  { route: "ProjectCalc", label: "Einsparpotential", icon: "mdi-speedometer" },
  { route: "ProjectEnergyFlow", label: "Energiebilanz", icon: "mdi-lightning-bolt-circle" },
  { route: "ProjectBenchmarking", label: "Benchmarking", icon: "mdi-table" },
  { route: "ProjectCalcValeri", label: "VALERI", icon: "mdi-calculator-variant" },
  { route: "ProjectReports", label: "Berichte", icon: "mdi-file-document-multiple" },
];

// Index of a route name within the page sequence (-1 if it is not a page).
// The parameter mirrors `RouteLocation['name']` from vue-router, which is
// `string | symbol | undefined` — a symbol never matches a route string, so it
// correctly falls through to -1.
export function projectPageIndex(
  routeName: string | symbol | null | undefined,
): number {
  return PROJECT_PAGES.findIndex((page) => page.route === routeName);
}
